import {
  createContext,
  useContext,
} from 'react';

const MaplibreMapContext = createContext(null);

export function useMaplibreMap() {
  const context = useContext(MaplibreMapContext);

  if (!context) {
    throw new Error('useMaplibreMap must be used within MaplibreMap');
  }

  return context;
}

export default MaplibreMapContext.Provider;
